import React from 'react';
import { Box } from '@mui/material';
import { deleteUser, getUser } from '../Auth/auth.service';
import CustomizedTables from '../../common/Table';
import { useCountryParam } from '../../common/util/useCountryParam';

const Users = () => {
    const country = useCountryParam();
    const columns: any[] = [
        // { key: "id", label: "ID", minWidth: 90 },
        { key: "name", label: "Name", minWidth: 150 },
        { key: "email", label: "Email", minWidth: 130 },
        { key: "number", label: "Mobile Number", minWidth: 150 },
        { key: "role", label: "Role", minWidth: 150 },
        { key: "status", label: "Status", minWidth: 100 },
    ];

    return (
        <Box sx={{ paddingY: 6, width: '100%' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>User List ({country.toUpperCase()})</h2>
            </Box>
            <CustomizedTables
                columns={columns}
                listService={getUser}
                deleteService={deleteUser}
                isUser={true}
            // editLink={'/editProperty'}
            />
        </Box>
    );
};

export default Users;
